module.exports = __webpack_public_path__ + "static/media/IBSU_Banner.4dd19fc7.jpg";